<div
  [class.opened]="isOpened"
  class="modal">

  <div class="modal-content">

    <amg-loader *ngIf="isLoading"
                class="pabsolute"></amg-loader>

    <div (click)="closeModal()"
         class="close-btn">
      <div class="close-btn__icon"></div>
    </div>

    <div class="box-data">
      <div class="header">
        <h3 class="header__title">{{wpCommonData.login.title}}</h3>
        <p class="header__description">{{wpCommonData.login.description}}</p>
      </div>
      <div class="content">
        <form (submit)="formSubmit()"
              [formGroup]="loginForm"
              class="content__form">
          <fieldset class="content__form-fieldset">
            <label class="content__form-label"
                   for="email">{{wpCommonData.login.email.label}}</label>
            <input [placeholder]="wpCommonData.login.email.input"
                   class="content__form-input"
                   formControlName="emailaddress"
                   id="email"
                   type="email"/>
            <div *ngIf="isFieldInvalid('emailaddress')"
                 class="error-txt">
              <span *ngIf="loginForm.controls['emailaddress'].hasError('required')"
                    [textContent]="wpCommonData.login.email.error_required"></span>
              <span *ngIf="loginForm.controls['emailaddress'].hasError('email')"
                    [textContent]="wpCommonData.login.email.error"></span>
              <span *ngIf="loginForm.controls['emailaddress'].hasError('server')"
                    [textContent]="loginForm.controls['emailaddress'].getError('server')"></span>
            </div>
          </fieldset>
          <fieldset class="content__form-fieldset">
            <label class="content__form-label"
                   for="password">{{wpCommonData.login.password.label}}</label>
            <div class="content__form-fieldset-password">
              <input [placeholder]="wpCommonData.login.password.input"
                     [type]="showPassword ? 'text' : 'password'"
                     class="content__form-input"
                     formControlName="password"
                     id="password"/>
              <div (click)="showPassword = !showPassword"
                   class="content__form-fieldset-password-toggle">
              </div>
            </div>
            <div *ngIf="isFieldInvalid('password')"
                 class="error-txt">
              <span *ngIf="loginForm.controls['password'].hasError('required')"
                    [textContent]="wpCommonData.login.password.error_required"></span>
              <span *ngIf="loginForm.controls['password'].hasError('minlength')"
                    [textContent]="wpCommonData.login.password.error"></span>
              <span *ngIf="loginForm.controls['password'].hasError('server')"
                    [textContent]="loginForm.controls['password'].getError('server')"></span>
            </div>
          </fieldset>
          <div class="content__form-cta">
            <button [textContent]="wpCommonData.login.submit"
                    class="btn btn-brand"
                    type="submit"></button>

            <div *ngIf="serverErrors.length"
                 class="error-txt">
              <span *ngFor="let error of serverErrors"
                    [textContent]="error"></span>
            </div>

          </div>
        </form>
        <div class="txt-forgot-pwd">
          <a [routerLink]="wpCommonData.pages.forgot_password"
             [textContent]="wpCommonData.login.link_forgot_password"></a>
        </div>
      </div>
      <div class="bottom">
        <div class="txt-new-account">
          <span class="bottom__text">{{wpCommonData.login.no_account}}</span>
          <a [routerLink]="wpCommonData.pages.packages"
             [textContent]="wpCommonData.login.sign_in"
             class="bottom__cta"></a>
        </div>
      </div>
    </div>
  </div>
</div>

